import { clsx, type ClassValue } from "clsx";
import { formatDate, formatDuration } from "date-fns";
import { es } from "date-fns/locale";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat("es", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
  }).format(amount);
}

export function formatDateES(date: Date): string {
  return formatDate(date, "d/M/yyyy", { locale: es });
}

export function formatDaysDuration(days: number): string {
  const years = Math.floor(days / 365);
  const months = Math.floor((days % 365) / 30);
  const remainingDays = (days % 365) % 30;
  return formatDuration(
    { years, months, days: remainingDays },
    {
      locale: es,
    },
  );
}
